module.exports = __webpack_public_path__ + "img/fef24e9c852e6f7261570317e6726ad.bae9e226.jpg";